<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";

    export let membershipGift = null;
    export let closeCallback;

    const initialize = () => {
        if (!membershipGift.id) {
            membershipGift = {
                id: 0,
                card_number: '',
                date: '',
                gift_el: '',
                gift_en: '',
                viewed_at: null,
            }
        }

        setFocusTo('cardNumber');
    }


    const save = () => {
        const onSuccess = result => {
            membershipGift.id = result.id;
            Notifier.showMessage("Το δώρο μέλους ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {
            console.log(err);
        };


        membershipGift.card_number = membershipGift.card_number.trim();
        membershipGift.gift_el = membershipGift.gift_el.trim();
        membershipGift.gift_en = membershipGift.gift_en.trim();

        if (!membershipGift.card_number) {
            Notifier.showError("Συμπληρώστε τον αριθμό κάρτας του μέλους!");
            setFocusTo("cardNumber");
            return;
        }

        if (!membershipGift.date) {
            Notifier.showError("Συμπληρώστε την ημερομηνία της κλήρωσης!");
            setFocusTo("giftDate");
            return;
        }

        if (!membershipGift.gift_el) {
            Notifier.showError("Συμπληρώστε το δώρο του μέλους στα Ελληνικά!");
            setFocusTo("giftEl");
            return;
        }
        if (!membershipGift.gift_en) {
            Notifier.showError("Συμπληρώστε το δώρο του μέλους στα Αγγλικά!");
            setFocusTo("giftEn");
            return;
        }

        let action = membershipGift.id == 0 ? 'create' : 'edit';
        R.handle(R.membershipGift[action], membershipGift, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        membershipGift = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if membershipGift}
    <Modal title="Δώρο Μέλους" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Αρ. Κάρτας</label>
                <input type="text" class="form-control" id="cardNumber" bind:value="{ membershipGift.card_number }">
            </div>
            <div class="form-group">
                <label>Ημερομηνία</label>
                <input type="date" class="form-control" id="giftDate" bind:value="{ membershipGift.date }">
            </div>
            <legend>Δώρο</legend>
            <div class="form-group">
                <label>Ελληνικά</label>
                <input type="text" class="form-control" id="giftEl" bind:value="{ membershipGift.gift_el }">
            </div>
            <div class="form-group">
                <label>English</label>
                <input type="text" class="form-control" id="giftEn" bind:value="{ membershipGift.gift_en }">
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}

